/**
 * Shared Interactive Garage vendor bind helpers (no module self-boot).
 * Used by interactive_garage.js (list/legacy PDP) and product_media rebind (React PDP).
 */

/**
 * @param {JQueryStatic} rp$
 * @returns {string|null}
 */
function getDealerCode(rp$) {
	const dealerCodeFromButton = rp$('.find-dealer-button[data-ig-dealer-code]').attr('data-ig-dealer-code');
	if (typeof dealerCodeFromButton === 'string' && dealerCodeFromButton.length > 0) {
		return dealerCodeFromButton;
	}

	const dealerCodeFromVehicle = rp$('.ig-vov-vehicle[data-ig-dealer-code]').attr('data-ig-dealer-code');
	if (typeof dealerCodeFromVehicle === 'string' && dealerCodeFromVehicle.length > 0) {
		return dealerCodeFromVehicle;
	}

	const igUrl = rp$('.ig-view-on-vehicle-wrapper[data-ig-url]').attr('data-ig-url');
	if (typeof igUrl === 'string') {
		const dealerCodePattern = /\/(ig\d+)\/?$/i;
		const match = dealerCodePattern.exec(igUrl);
		if (match) {
			return match[1];
		}
	}

	return null;
}

/**
 * @param {JQueryStatic} rp$
 * @param {'product'|'list'} targetViewType
 * @returns {void}
 */
function initializeInteractiveGarage(rp$, targetViewType) {
	const igSettings = typeof igViewOnVehicleSettings === 'undefined' ? undefined : igViewOnVehicleSettings;
	if (typeof rp$.igViewOnVehicle === 'function') {
		rp$.igViewOnVehicle(targetViewType, getDealerCode(rp$), igSettings);
		return;
	}

	// Fallback to global igViewOnVehicle if rp-scoped function is not available
	if (typeof igViewOnVehicle === 'function') {
		igViewOnVehicle(targetViewType, getDealerCode(rp$), igSettings);
	}
}

module.exports = {
	getDealerCode,
	initializeInteractiveGarage,
};
